import { Component, OnInit } from '@angular/core';
import { AdSpaceEnum, AdvertOrder, EditAdvertOrderModel } from '../../../models/inModels/Advert';
import { Message } from "primeng/components/common/message";
import { SelectItem } from "primeng/components/common/selectitem";
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from '../../../services/system/storage.service';
import { AdvertOrderService } from '../../../services/business/advert-order.service';

@Component({
	selector: 'app-advert-order-edit',
	templateUrl: './advert-order-edit.component.html',
	styleUrls: ['./advert-order-edit.component.css']
})
export class AdvertOrderEditComponent implements OnInit {
	AdSpaceEnum = AdSpaceEnum;
	id;
	model: AdvertOrder;
	loading = false;
	error: Message[];
	uploading = false;
	selectedAdvertType;
	advertTypeId: SelectItem[];
	adverts;
	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private service: AdvertOrderService,
		private storageService: StorageService) {
		this.id = this.route.snapshot.paramMap.get('Id');
	}

	ngOnInit(): void {
		this.getAdvertOrder();
	}

	getAdvertOrder() {
		this.loading = true;
		this.service.get(this.id).then(
			result => {
				this.model = new AdvertOrder(result);
				if (this.model.IsLive && !this.model.IsPaidFor) {
					this.error = [];
					this.error.push({ severity: 'warn', summary: 'Warning', detail: "You have set this Advert Order to LIVE while it's PAYMENT STATUS is false!"});
				}
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	initAdvertTypeDropDown(event): void {
		this.service.getDropdownList(event).then(
			x => {
				this.adverts = x;
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}
	goBack(): void {
		this.router.navigate(['/advert-order']);
	}

	save() {
		this.loading = true;
		const setToLive = this.model.IsLive;
		const model = new EditAdvertOrderModel(this.model);
		this.service.update(model, setToLive).then(
			result => {
				this.loading = false;
				this.model = new AdvertOrder(result);
				this.error = [];
				this.error.push({ severity: 'success', summary: 'Success', detail: "Event saved" });
				setTimeout(() => {
					if (this.model.IsLive && !this.model.IsPaidFor) {
						this.error = [];
						this.error.push({ severity: 'warn', summary: 'Warning', detail: "You have set this Advert Order to LIVE while it's PAYMENT STATUS is false!"});
					}
				}, 300);
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
		});
	}

	handleError(event): void {
		this.loading = false;
		this.error = [];
		this.storageService.handleError(event, this.error);
	}

}



// WEBPACK FOOTER //
// ./src/app/components/advert-order/advert-order-edit/advert-order-edit.component.ts